import React, { useState } from 'react';
import { useDispatch, useSelector, fetchSendReceipt } from '../../../stores';

import { Modal, Input, Button } from '../../../components';
import { StyledModalWrapper, StyledButtonsWrapper, StyledInputWrapper } from '../styles';

export const TicketSendEmailModal = (props: {
  isOpen: boolean
  handleClose: () => void
  isLoading: boolean
}) => {
  const dispatch = useDispatch();

  const { ticketDetails } = useSelector((state) => state.historyReducer);
  const { driverId, name, email: driverEmail } = useSelector((state) => state.profileReducer);
  const [email, setEmail] = useState(driverEmail);

  const handleSendTicketByEmail = () => {
    if(ticketDetails) {
      dispatch(
        fetchSendReceipt({
          driverId: driverId.toString(),
          ticketId: ticketDetails.id,
          name: name,
          email: email
        })
      );
    }
  }

  return(
    <Modal
      title='Digite seu email'
      open={props.isOpen}
      onClose={props.handleClose}
    >
      <StyledModalWrapper>
        <StyledInputWrapper>
          <Input
            name='email'
            type='text'
            mask='email'
            label='Email'
            margin='normal'
            value={email}
            onChange={(value: string) => setEmail(value)}
            maxLength={14}
            style={{ width: '100%' }}
          />
        </StyledInputWrapper>
        <StyledButtonsWrapper>
          <Button
            variant='contained'
            label='Enviar'
            type='submit'
            onClick={handleSendTicketByEmail}
            color='secondary'
            loading={props.isLoading}
            style={{ width: '100%' }}
          />
        </StyledButtonsWrapper>
      </StyledModalWrapper>
    </Modal>
  );
}